module.exports = __webpack_public_path__ + "static/media/investor-mob.058b6a90.png";